/* import __COLOCATED_TEMPLATE__ from './list-select.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface SelectOptionData {
  value: number | string;
  display: string;
}

interface ListSelectSignature {
  Args: {
    options: SelectOptionData[];
    disabled?: boolean;
    enableFilters?: boolean;
    selectedValue?: number | string;
    valueChanged: (value: number | string) => void;
  };
  Element: HTMLSelectElement;
}

export default class ListSelect extends Component<ListSelectSignature> {
  selectElement: HTMLSelectElement | null = null;
  @action onChange(evt: Event) {
    if (!this.args.disabled && evt.target && evt.target instanceof HTMLSelectElement) {
      if (this.args.valueChanged) {
        this.args.valueChanged(evt.target.value);
      }
    }
  }
  @action insertingSelect(element: HTMLSelectElement) {
    this.selectElement = element;
    this.selectElement.value = (this.args.selectedValue ?? '').toString();
  }
  @action destroyingSelect() {
    this.selectElement = null;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ListSelect: typeof ListSelect;
  }
}
